$(document).ready(function(){
    var weeks, tabs, weekCont, contents, weekNum;
    contents = $('#section-4');
    tabs = $('#tabWeeks');
    weekCont = $('#weekCont');
    weekNum = contents.data('week');
    weeks = function(week){
        contents.removeClass().addClass('weeks-'+week);
        tabs.find('li').removeClass('active').eq(week - 1).addClass('active');
        weekCont.find('.con').hide().eq(week - 1).show();
    }
    weeks(weekNum);
    tabs.find('button').not('button[data-alert]').on('click',function(){
        weekNum = $(this).data('weeknum');
        weeks(weekNum);
    });
});



// WEBPACK FOOTER //
// ./src/js/index.js